<template>
    <div>
        <QueroTaxiRoot v-if="getUser.nome === 'root'" />
        <QueroTaxiUser v-else />

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QueroTaxiRoot from './root/QueroTaxi'
import QueroTaxiUser from './user/QueroTaxi'

export default {
    components: {
        QueroTaxiRoot,
        QueroTaxiUser
    },

    computed: {
        ...mapGetters(['getUser'])
    }
}
</script>



// WEBPACK FOOTER //
// src/components/QueroTaxi.vue